import React, { useState } from "react";
import { TextField, MenuItem, Box, IconButton } from "@mui/material";
import SearchIcon from "@material-ui/icons/Search";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import RefreshIcon from "@material-ui/icons/Refresh";
import styleSheet from "../styleSheet";

const ReportFilters = ({
  report,
  reports,
  searchBy,
  searchByValue,
  search,
  onReportChange,
  onSearchByChange,
  onSearchChange,
  onSearch,
  onDownload,
  onReset,
  disableDownload,
  downloadSx = {},
  resetSx = {},
  searchSx = {},
}) => (
  <Box display="flex" gap={2} alignItems="center">
    <TextField
      select
      label="Select Report"
      value={report}
      sx={{ width: 250, backgroundColor: "white" }}
      onChange={(e) => onReportChange(e.target.value, search, searchByValue)}
    >
      {reports.map(({ key, label }) => (
        <MenuItem key={key} value={key}>
          {label}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      select
      value={searchByValue}
      disabled={!report}
      sx={{ width: 250, backgroundColor: "white" }}
      onChange={(e) => onSearchByChange(e.target.value)}
    >
      {searchBy.map((r) => (
        <MenuItem key={r.value} value={r.value}>
          {r.label}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      placeholder="Search"
      disabled={!searchByValue}
      sx={{ width: 250, backgroundColor: "white" }}
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
    />

    <IconButton
      onClick={() => onSearch(search, searchByValue, report)}
      sx={searchSx}
      disabled={!search?.trim()}
    >
      <SearchIcon />
    </IconButton>
    <IconButton
      onClick={onReset}
      sx={resetSx}
    >
      <RefreshIcon />
    </IconButton>
    <Box flexGrow={1} />

    <IconButton onClick={onDownload} sx={downloadSx} disabled={disableDownload}>
      <CloudDownloadIcon />
    </IconButton>
  </Box>
);

export default ReportFilters;
